var path = 'msi/modals/close/close.html';
var html = "<a class=\"og-modal-close\" ng-click=\"$ctrl.dismiss()\" aria-hidden=\"true\">\n  <span class=\"fa fa-remove\"></span>\n</a>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;